
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/free/[tool]",
      function () {
        return require("private-next-pages/features/free/[tool].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/free/[tool]"])
      });
    }
  